import { AuthService } from '@/services'
import Cookies from 'js-cookie'
import liff from '@line/liff'
import { COOKIE_ACCESS_TOKEN, COOKIE_LINE_TOKEN, PROVIDER } from '@/constants'

export default {
  namespaced: true,
  state: () => ({
    user: null,
    initial: false,
    shop: null,
    shopName: '',
  }),

  getters: {
    isLogin(state) {
      return !!state.user
    },
    user(state) {
      return state.user
    },
    shop(state) {
      return state.shop
    },
    getShopName(state) {
      return state.shopName
    },
  },

  mutations: {
    SET_USER(state, data) {
      state.user = data
    },

    SET_SHOP(state, data) {
      state.shop = data
    },

    REMOVE_USER(state) {
      state.user = null
    },

    SET_INIT(state) {
      state.initial = true
    },

    SET_SHOP_NAME(state, data) {
      state.shopName = data
    },
  },

  actions: {
    async getAuth({ commit, dispatch }, { provider = PROVIDER.LINE }) {
      if (provider === PROVIDER.LINE) {
        const { data } = await AuthService.login({
          accessToken: liff.getAccessToken(),
        })

        if (data.access_token) {
          Cookies.set(COOKIE_ACCESS_TOKEN, data.access_token)
          dispatch('menu/getInvalidSubscription', null, { root: true })
        } else {
          Cookies.remove(COOKIE_ACCESS_TOKEN)
        }
        commit('SET_USER', data.customer)
      } else if (provider === PROVIDER.CUSTOMER && Cookies.get(COOKIE_ACCESS_TOKEN)) {
        try {
          const { data } = await AuthService.me()

          if (!data) {
            Cookies.remove(COOKIE_ACCESS_TOKEN)
          } else {
            dispatch('menu/getInvalidSubscription', null, { root: true })
          }
          commit('SET_USER', data)
        } catch (error) {
          Cookies.remove(COOKIE_ACCESS_TOKEN)
          commit('SET_USER', null)
        }
      }
    },

    async removeAuth({ commit }) {
      liff.ready.then(() => {
        liff.isLoggedIn() && liff.logout()
      })

      // Clean cookies
      Cookies.remove(COOKIE_LINE_TOKEN)
      Cookies.remove(COOKIE_ACCESS_TOKEN)

      // Clean store
      commit('REMOVE_USER')
    },
  },
}
